//创建vue根实例
import Vue from 'vue'
//导入
// import App from './App.vue'

// import  'vue-tabs-component/docs/resources/tabs-component.css';
// import {Tabs, Tab} from 'vue-tabs-component';

import {Tabs, Tab} from '~lib/vue-tabs/index.js';
import  '~css/tabs-component.css';
// require('~css/tabs-component.css');


Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

//引入bootstrap
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);
// import router from './router';
import App from './App.vue';

import DataV from '@jiaminghi/data-view'

// import {borderBox1} from '@jiaminghi/data-view'

// Vue.use(borderBox1); //按需引入
Vue.use(DataV);//全量引入

new Vue({
    el:'#app',
    // router,
    components:{

        App
    },
    template:'<App/>'
})
